<template>
  <div class="simple_card" :class="classes">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ["classes"],
};
</script>

<style lang="scss">
.simple_card {
  width: fit-content;
  margin-block: 12px;
  background: var(--white);
  border-radius: 18px;
  padding: 16px 20px;
  margin-inline-end: 10px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 18px 30px rgba(15, 23, 42, 0.08);
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 170px;

  p {
    margin: 0;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 1px;
    text-transform: capitalize;
    color: var(--mainText);

    .value {
      font-size: 18px !important;
      font-weight: 700;
    }

    .v-icon {
      color: var(--main);
      font-size: 20px;
      margin-inline-start: 8px;
      transition: color 0.2s ease;
      &.trip {
        margin-inline-start: 0px;
        margin-inline-end: 8px;
      }
    }

    span.active {
      color: #26be00;
    }
    span.inactive {
      color: #ff0000;
    }
  }
}
</style>

